import React from 'react'
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import ClientComp from './ClientComp'

function Clients() {
  return (
   <div className='contentMain'> 
        <LeftBar/>
        <div className='theRightOne'> 
          <div className='DashTop'>
            <h1>Clients</h1>
            <NavBar/>
          </div>
          <ClientComp/>
        </div>    
    </div>
  )
}

export default Clients